export const radix_bases = {
  base10: 10,
  base2: 2
}